import { BrowserRouter , Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Subcription from "./Pages/Subcription";
import Contact from "./Pages/Contact";
import Login from "./Pages/Auth/Login";
import Signup from "./Pages/Auth/Signup";
import Profile from "./Pages/Profile";
import Error from "./Pages/Error";
import BlogDetail from "./Pages/BlogDetail";
import Verification from "./Pages/Auth/Verification";
import Forgot from "./Pages/Auth/Forgot";
import UpdatePassword from "./Pages/Auth/UpdatePassword";
import ChangePassword from "./Pages/Auth/ChangePassword";
import SearchProfile from "./Pages/SearchProfile";
import Success from "./Pages/PagePaypal/Success";
import Errors from "./Pages/PagePaypal/Errors";
import HowIts from "./Pages/HowIts";


function App() {
  return (
   <>
   <BrowserRouter>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/subscription" element={<Subcription />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/howit" element={<HowIts />} />
        <Route path="/blogdetail" element={<BlogDetail />} />
        <Route path="/verification" element={<Verification />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/searchprofile" element={<SearchProfile />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/updatepassword/:id" element={<UpdatePassword />} />
        <Route path="/changepassword" element={<ChangePassword />} />
        <Route path="/success/:param1/*" element={<Success />} />
        <Route path="/error/:param1/*" element={<Errors />} />
        <Route path="/*" element={<Error />} />
        </Routes>
      </BrowserRouter>
   </>
  );
}

export default App;



